<template>
  <div class="opinion-scale__container">
    <div
      v-if="hasError === true"
      class="ui negative small message">
      <div>
        Please choose 1 option.
      </div>
    </div>

    <table>
      <tr>
        <td
          v-for="(step, index) in stepsChoices"
          :key="index"
          :class="{'state-selected': (selectedValueModel === step), 'state-unselected': !(selectedValueModel === step)}"
          @click="setSelectedValueModel(step)">
          {{ step }}
        </td>
      </tr>
    </table>

    <div class="opinion-scale__labels">
      <div>
        {{ labelLeft }}
      </div>
      <div>
        {{ labelRight }}
      </div>
    </div>

    <button
      v-if="buttonIsVisible === true"
      class="button__submit"
      @click="setAnswer();">
      OK
    </button>
  </div>
</template>

<script>
export default {
  name: 'OpinionScale',
  props: {
    readOnly: {
      type: Boolean,
      default: true
    },
    question: {
      type: Object,
      required: true,
      default: function () {
        return null
      }
    },
    answer: {
      type: null,
      required: false,
      default: function () {
        return {
          number: null
        }
      }
    }
  },
  data () {
    return {
      selectedValueModel: null,
      hasError: false,
      buttonIsVisible: false
    }
  },
  computed: {
    questionId: function () {
      return this.question.id
    },
    selectedValue: function () {
      let selectedValue = null
      if (this.answer.number !== '' || this.answer.number !== undefined || this.answer.number !== null) {
        selectedValue = this.answer.number
      }
      return selectedValue
    },
    steps: function () {
      return this.question.properties.steps || 5
    },
    startAtOne: function () {
      return this.question.properties.start_at_one || false
    },
    labelLeft: function () {
      return this.question.properties.labels.left || 'Not at all'
    },
    labelRight: function () {
      return this.question.properties.labels.right || 'Severely affected'
    },
    stepsChoices: function () {
      let stepsChoices = []
      let i = 0
      if (this.startAtOne === true) {
        i = 1
      }
      for (i; i <= this.steps; i++) {
        stepsChoices.push(i)
      }
      return stepsChoices
    },
    buildAnswerFormat: function () {
      let answer = {
        'type': 'number',
        'number': this.selectedValueModel,
        'field': {
          'id': this.questionId,
          'type': 'opinion_scale'
        }
      }
      return answer
    }
  },
  watch: {
    selectedValueModel (value) {
      if (value !== '' && value !== undefined && value !== null && (this.selectedValue === '' || this.selectedValue === undefined || this.selectedValue === null)) {
        this.setAnswer()
      } else if (this.selectedValue !== undefined && this.selectedValue !== null && this.selectedValue !== '') {
        // NOTE: Commented out to prevent OK button from showing in read-only mode
        // if (value !== '' && value !== undefined && value !== null) {
        //   this.buttonIsVisible = true
        // } else {
        //   this.buttonIsVisible = false
        // }
        // NOTE: Remove this and uncomment the above if showing OK button in read-only mode is desired
        this.buttonIsVisible = false
      }
    },
    selectedValue (value) {
      if (value) {
        this.selectedValueModel = this.selectedValue
      }
    }
  },
  mounted () {
    if (this.selectedValue !== undefined && this.selectedValue !== null && this.selectedValue !== '') { // selectedValueModel = selectedValue
      this.selectedValueModel = this.selectedValue
      this.buttonIsVisible = true
    };
  },
  deactivated () {
    this.selectedValueModel = null
    this.hasError = false
  },
  methods: {
    setSelectedValueModel: function (step) {
      if (this.readOnly) return
      if (step !== undefined || step !== null || step !== '') {
        // Note: Don't allow deselect
        this.selectedValueModel = step

        // if (this.selectedValueModel === step) {
        //   this.selectedValueModel = null
        // } else {
        //   this.selectedValueModel = step
        // }
      }
    },
    isAnswerValid: function () {
      return new Promise((resolve, reject) => {
        this.hasError = false
        if (!this.questionId || this.selectedValueModel === undefined || this.selectedValueModel === null || this.selectedValueModel === '') {
          this.hasError = true
          this.$emit('invalidAnswer')
        } else if (this.startAtOne === true && (this.selectedValueModel > this.steps || this.selectedValueModel < 1)) {
          this.hasError = true
          this.$emit('invalidAnswer')
        } else if (this.startAtOne === false && (this.selectedValueModel > this.steps || this.selectedValueModel < 0)) {
          this.hasError = true
          this.$emit('invalidAnswer')
        }
        resolve()
      })
    },
    setAnswer: function () {
      this.isAnswerValid().then(() => {
        this.setSelectedValue()
      },
      (err) => {

      })
    },
    setSelectedValue: function () {
      if (this.$route.name !== 'ReadOnlyAssessment') {
        this.$emit('save', this.buildAnswerFormat)
      }
    }
  }
}
</script>

<style scoped>
.opinion-scale__container {
  width: 100%;
  margin: 0.875rem 0;
}

table {
  width: 100%;
  margin-bottom: 0.5em;
  border-spacing: 0;
  border: 0.125rem solid #6496bb;
  border-radius: 0.28571429rem;
  font-size: 1.28571429rem;
  color: #6496bb;
  overflow: hidden;
}

td {
  text-align: center;
  padding: 0.875rem 0;
  border-right: 0.125rem solid #6496bb;
}

td:last-child {
  border-right: none;
}

.state-unselected {
  background-color: white;
  /*box-shadow: 0 0 0 2px #6496bb inset;*/
  color: #6496bb;
  font-weight: 300;
}

.state-selected {
  background-color: #6496bb;
  color: white;
  font-weight: 700;
}

.opinion-scale__labels {
  display: flex;
  justify-content: space-between;
  color: #6496bb;
  font-weight: 700;
}

.button__submit {
  width: 100%;
  padding: 0.875rem;
  margin: 0.875rem 0;
  font-size: 1.28571429rem;
  border-radius: 0.28571429rem;
  overflow: hidden;
  border: none;
  background-color: #6496bb;
  color: white;
  font-weight: 500;
}
</style>
